import DayView from "./Views/Day";
import WeekView from "./Views/Week";
import TimelineView from "./Views/Timeline";
import MapView from "./Views/Map";
import ListView from "./Views/List";
import ResourceDayView from "./Views/Resource";
import { VIEW_TYPES } from "./constants";
import { SchedulerViewDefinition } from "./types/views";
import { ViewType } from "./types/common";

export const builtInSchedulerViews: SchedulerViewDefinition[] = [
  {
    type: VIEW_TYPES.TIMELINE as ViewType,
    label: "Timeline",
    component: TimelineView,
  },
  {
    type: VIEW_TYPES.DAY as ViewType,
    label: "Day",
    component: DayView,
  },
  {
    type: VIEW_TYPES.WEEK as ViewType,
    label: "Week",
    component: WeekView,
  },
  {
    type: VIEW_TYPES.RESOURCE as ViewType,
    label: "Resource",
    component: ResourceDayView,
  },
  {
    type: VIEW_TYPES.LIST as ViewType,
    label: "List",
    component: ListView,
  },
  {
    type: VIEW_TYPES.MAP as ViewType,
    label: "Map",
    component: MapView,
  },
];

export const getSchedulerViews = (
  customViews: SchedulerViewDefinition[] = [],
  visibleViewTypes?: ViewType[]
) => {
  const merged = [...builtInSchedulerViews];

  customViews.forEach((customView) => {
    const existingIndex = merged.findIndex((view) => view.type === customView.type);

    if (existingIndex >= 0) {
      merged[existingIndex] = customView;
      return;
    }

    merged.push(customView);
  });

  if (!visibleViewTypes?.length) {
    return merged;
  }

  return merged.filter((view) => visibleViewTypes.includes(view.type));
};

export const getSchedulerViewByType = (
  currentView: ViewType,
  customViews: SchedulerViewDefinition[] = [],
  visibleViewTypes?: ViewType[]
) => {
  const availableViews = getSchedulerViews(customViews, visibleViewTypes);
  return availableViews.find((view) => view.type === currentView);
};
